// extracted by mini-css-extract-plugin
module.exports =  {"name":"FS8RhT9","grey-1200":"RIjcbTF","grey1200":"RIjcbTF"};